<template>
  <div>
    <pea-summary ref="peaSummary" :peaId="mainPeaId" :disabled="disableEditing" v-on:updateYears="updateYears"></pea-summary>
    <br v-if="this.mainPeaId != 0"/>
    <pea-status-history v-if="this.mainPeaId != 0" ref="peaStatusHistory" :peaId="mainPeaId"></pea-status-history>
    <br v-if="this.mainPeaId != 0"/>
    <pea-financial-assets v-if="this.mainPeaId != 0" ref="peaFinancialAssets" v-on:peaFAClassChange="determinePeaCheckLegalStatus"  :peaId="mainPeaId" :disabled="disableEditing" :startingYear="startingYear"></pea-financial-assets>
    <br v-if="this.mainPeaId != 0"/>
    <pea-cri v-if="this.mainPeaId != 0" ref="peaCRI" :peaId="mainPeaId" :disabled="disableEditing" :disableButton="disableCRI"></pea-cri>
    <br v-if="this.mainPeaId != 0"/>
    <pea-documents v-if="this.mainPeaId != 0" ref="peaDocuments" :peaId="mainPeaId" :disabled="disableDocuments"></pea-documents>
    <br v-if="this.mainPeaId != 0"/>
    <pea-financial-summary v-if="this.mainPeaId != 0" ref="peaFinancialSummary" :peaId="mainPeaId" :disabled="disableFinancialSummary" :canEditCostToDate="false"></pea-financial-summary>
    <br v-if="this.mainPeaId != 0"/>
    <pea-check v-if="this.mainPeaId != 0" ref="peaCheck" :peaId="mainPeaId" :disabled="disableEditing"></pea-check>
    <br v-if="this.mainPeaId != 0"/>
    <pea-authorization v-if="this.mainPeaId != 0" ref="peaAuthorization" :peaId="mainPeaId" :canEditPea="this.canEditPEA" :isApprover="this.isApprover"></pea-authorization>
    <br v-if="this.mainPeaId != 0"/>
    <pea-comment v-if="this.mainPeaId != 0" ref="peaComment" :peaId="mainPeaId" :disabled="disableEditing" ></pea-comment>
    <br v-if="this.mainPeaId != 0"/>
    <div v-if="this.mainPeaId == 0">
      Invalid PEA ID to clone
    </div>
    <br />

    <el-alert v-if="alertTitle !== ''"
      :title="alertTitle"
      :type="alertType"
      :description="callInfo"
      :closable="false"
      show-icon>
    </el-alert>

    <div v-if="this.mainPeaId != 0">
      <h4>What this does</h4>
      <ul>
        <li>This PEA's data is saved as a new PEA  with a new ID in the database.</li>
        <li>The new PEA is <strong>NOT</strong> submitted for approval.</li>
      </ul>
      <h4>Following data is <strong>NOT</strong> cloned</h4>
      <ul>
        <li>Any Approvals/Denials (Those assigned to Approve the PEA may or may not be the same based on current PEA rules)</li>
        <li>Any Comments</li>
        <li>Status History</li>
      </ul>
      <el-button type="primary" class="btn btn-primary" :loading="this.isLoading" @click="clonePEA()">Clone This PEA</el-button>
    Submit Processing...
    </div>
  </div>
</template>

<script>
import router from '../router'
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'peaClone',
  props: [
    'peaId'
  ],
  data () {
    return {
      isLoading: false,
      callInfo: '',
      alertType: '',
      alertTitle: '',
      peaSummaryValidState: false,
      peaFinancialAssetValidState: false,
      mainPeaId: this.peaId,
      disableEditing: true,
      canEditPEA: false,
      canEditPartialPEA: false,
      isApprover: false,
      canApprovePEA: false,
      canWithdrawPEA: false,
      disableFinancialSummary: true,
      disableCRI: true,
      disableDocuments: true,
      startingYear: new Date().getFullYear(),
      clonePeaId: 0
    }
  },
  created: function () {
    this.$on('peaSummaryValidation', function (value) {
      this.peaSummaryValidState = value
      this.isLoading = false
    })
    this.$on('peaFinancialAssetValidation', function (value) {
      this.peaFinancialAssetValidState = value
      this.isLoading = false
    })
  },
  methods: {
    updateYears () {
      this.startingYear = this.$refs.peaSummary.peaCore.projectStartDate.getFullYear()
    },
    determinePeaCheckLegalStatus () {

    },
    clonePEA () {
      // catch multi clicks
      if (this.isLoading === true) {
        return
      }
      this.isLoading = true
      this.alertTitle = ''
      const loading = this.$loading({
        lock: true,
        text: 'Processing',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var call = '/clonePEA/' + this.peaId
      return new Promise((resolve, reject) => {
        this.$axios.post(call).then(response => {
          this.clonePeaId = response.data.id
          loading.close()
          this.isLoading = false
          helperMethods.showNotification(this, 'Clone successful', 'PEA #' + this.clonePeaId + ' has been created.', 'success', 10000)
          router.push('/editPEA/' + this.clonePeaId)
          scrollTo(0, 0)
          resolve(response)
        }).catch(response => {
          this.isLoading = false
          loading.close()
          helperMethods.showNotification(this, 'Clone failed', response.body, 'error', 30000)
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
